export default {"src":"/_next/static/media/SubDesc3.aab3181a.svg","height":201,"width":200,"blurWidth":0,"blurHeight":0};